// components/CustomSnackbar.tsx
import React, { useEffect } from 'react';
import { Transition, Paper, Text } from '@mantine/core';

interface CustomSnackbarProps {
  opened: boolean;
  message: string;
  onClose: () => void;
  duration?: number;
  backgroundColor?: string; // Nova propriedade para customizar a cor de fundo
}

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  opened,
  message,
  onClose,
  duration = 3000,
  backgroundColor = 'red', // valor padrão: vermelho
}) => {
  useEffect(() => {
    if (opened) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [opened, duration, onClose]);

  return (
    <Transition mounted={opened} transition="slide-down" duration={300} timingFunction="ease">
      {(styles) => (
        <Paper
          style={{
            ...styles,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '40px',
            backgroundColor,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            padding: 0,
          }}
          withBorder
        >
          <Text color="white" size="md" style={{ lineHeight: '20px' }}>
            {message}
          </Text>
        </Paper>
      )}
    </Transition>
  );
};

export default CustomSnackbar;
